import React from 'react';
import { Provider } from 'react-redux';
import SiteLayout from './index';
export default class Container extends React.Component {
    render() {
        return (React.createElement(Provider, { store: this.props.store },
            React.createElement(SiteLayout, null)));
    }
}
